module.exports = __webpack_public_path__ + "static/media/splash_IMG_3933.a7b612db.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/search/img/splash_IMG_3933.png
// module id = 944
// module chunks = 23